let
    atTopOfPage = true,
    scrollTimeout = null;
const
    shadow = document.querySelector('[data-role="header-shadow"]'),
    headerShadowClassName = 'opacity-100',
    processingHeaderScrolling = () => {

        if (scrollTimeout == null) {
            scrollTimeout = setTimeout(() => {

                if (window.scrollY > 0) {

                    if (atTopOfPage) {

                        shadow.classList.add(headerShadowClassName);
                        atTopOfPage = false;
                    }
                }
                else if (!atTopOfPage) {

                    shadow.classList.remove(headerShadowClassName);
                    atTopOfPage = true;
                }
                scrollTimeout = null;
            }, 250);
        }
    };

let headerScrollingHandled = false;
const handleHeaderScrolling = () => {

    if (!headerScrollingHandled) {

        headerScrollingHandled = true;

        shadow.classList.remove('hidden');
        window.addEventListener('scroll', () => processingHeaderScrolling());
    }
};

handleHeaderScrolling();

let timeoutResize = null;
window.addEventListener('resize', () => {

    if (!headerScrollingHandled) {

        clearTimeout(timeoutResize);
        timeoutResize = setTimeout(handleHeaderScrolling, 500);
    }
});